// Per-type section heading + blurb shown above a tab's cards
// (Figma 1123-86923, 1249-8999, 1123-89611). Shared by the dashboard panel and
// the My Courses page so the wording lives in exactly one place.

const SECTIONS = {
  current: {
    title: 'Current',
    description: 'These courses are currently available for you to access and complete.'
  },
  upcoming: {
    title: 'Upcoming',
    description: "These courses haven't started yet and will become available on their scheduled start date."
  },
  transcript: {
    title: 'Transcript',
    description:
      'Track courses that are ready to transcript, currently being processed, or already added to your transcript.'
  },
  expired: {
    title: 'Expired',
    description: 'These courses are no longer available, and you no longer have access to their content.'
  },
  unenrolled: {
    title: 'Unenrolled',
    description: 'These are the courses you have unenrolled from. You would have to reenroll in Add Courses for access.'
  }
};

/** Copy for a tab, or null for tabs that have no heading of their own (e.g. "all"). */
export function sectionCopyFor(tab) {
  return SECTIONS[tab] || null;
}
